/* global femcare, Swiper */

femcare.product.panel.info.slider = {
    init() {
        const slider = document.querySelector('.product-main__info-panel .suggested-products__slider');

        if (slider) {
            const swiperElement = slider.querySelector('.swiper');
            const nextButton = slider.querySelector('.suggested-products-slider__next');
            const prevButton = slider.querySelector('.suggested-products-slider__previous');

            new Swiper(swiperElement, {
                lazy: true,
                spaceBetween: 10,
                breakpoints: {
                    400: { slidesPerView: 1.25 },
                    550: { slidesPerView: 1.75 },
                    992: { slidesPerView: 1 },
                    1070: { slidesPerView: 1.25 },
                    1500: { slidesPerView: 2 }
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton
                }
            });
        }
    }
};
